import React from 'react';

function getPageNumbers(current, total) {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const seen = new Set();
  const pages = [];

  const add = (v) => {
    if (typeof v === 'number') {
      if (!seen.has(v)) {
        seen.add(v);
        pages.push(v);
      }
    } else {
      if (pages.length > 0 && pages[pages.length - 1] === '...') return;
      pages.push('...');
    }
  };

  add(1); add(2); add(3);

  if (current <= 4) {
    add(4); add(5);
    add('...');
  } else if (current >= total - 3) {
    add('...');
    add(total - 4); add(total - 3); add(total - 2);
  } else {
    add('...');
    add(current - 1); add(current); add(current + 1);
    add('...');
  }

  add(total - 2); add(total - 1); add(total);

  return pages;
}

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const pageNumbers = getPageNumbers(currentPage, totalPages);

  return (
    <div className="flex items-center justify-center gap-0.5 pt-4 pb-1">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage <= 1}
        className="px-2 py-1 text-sm font-medium text-gray-500 disabled:text-gray-300 disabled:cursor-not-allowed hover:text-gray-900 transition-colors"
      >
        ← Previous
      </button>

      <div className="flex items-center gap-0.5">
        {pageNumbers.map((p, i) =>
          p === '...' ? (
            <span key={`ellipsis-${i}`} className="px-1.5 py-1 text-sm text-gray-400 select-none">
              ...
            </span>
          ) : (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              className={`min-w-[28px] h-7 px-2 rounded-md text-xs font-medium transition-colors ${
                p === currentPage
                  ? 'bg-[#111827] text-white'
                  : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'
              }`}
            >
              {p}
            </button>
          )
        )}
      </div>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        className="px-2 py-1 text-sm font-medium text-gray-500 disabled:text-gray-300 disabled:cursor-not-allowed hover:text-gray-900 transition-colors"
      >
        Next →
      </button>
    </div>
  );
};

export default Pagination;
